module.exports = __webpack_public_path__ + "img/france-leukaemia-female.06fa4b55.png";